import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';

import TrustlyPaymentMarksAlt from '@/assets/icons/trustly-payment-marks-alt';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { navigateToKyc } from '@/navigation/navigation';

import { AddPaymentMethod } from './AddPaymentMethod';
import { PreferredTag } from './PreferredTag';

export const AddPaymentMethodTrustly = () => {
    const navigation = useNavigation();
    const { t } = useTranslation('transactions');

    return (
        <AddPaymentMethod
            icon={<TrustlyPaymentMarksAlt />}
            title={t('trustly')}
            description={t('trustly_description')}
            tag={<PreferredTag />}
            onPress={() => {
                navigateToKyc(navigation, { screen: 'TrustlyWebview' });
            }}
            analyticsEvent={AnalyticsEvent.DEPOSIT_METHOD_ADD_IBT}
        />
    );
};
